import { render, staticRenderFns } from "./NavFiltrados.vue?vue&type=template&id=22b84c1c&"
import script from "./NavFiltrados.vue?vue&type=script&lang=js&"
export * from "./NavFiltrados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports